import { apiClientGeral } from '@/plugins/axios'

export default {
  getFirewallConfig() {
    return apiClientGeral().get('/config')
  },

  putFirewallConfig(data) {
    return apiClientGeral().put('/config', data)
  },

}
